(function() {
  'use strict';

  const productForm = document.querySelector('[data-product-form]');
  if (!productForm) return;

  const productJsonEl = document.querySelector('[data-product-json]');
  const productJson = productJsonEl ? JSON.parse(productJsonEl.textContent) : {};

  // ============================================
  // Image Gallery
  // ============================================
  function initGallery() {
    const thumbnails = document.querySelectorAll('[data-product-thumbnail]');
    const mainImage = document.querySelector('[data-product-main-image]');

    if (!thumbnails.length || !mainImage) return;

    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();

        const newSrc = this.getAttribute('data-image-url');
        const newAlt = this.getAttribute('data-image-alt');
        if (!newSrc) return;

        mainImage.src = newSrc;
        if (newAlt) mainImage.alt = newAlt;

        // Update active state
        thumbnails.forEach(t => {
          t.classList.remove('border-onyx');
          t.classList.add('border-shadow');
        });
        this.classList.remove('border-shadow');
        this.classList.add('border-onyx');
      });
    });
  }

  // ============================================
  // Variant Selection
  // ============================================
  function initVariantSelection() {
    const optionButtons = document.querySelectorAll('[data-variant-option]');
    const variantIdInput = document.querySelector('[data-variant-id]');
    const priceEl = document.querySelector('[data-product-price]');
    const addToCartBtn = productForm.querySelector('button[type="submit"]');
    const mainImage = document.querySelector('[data-product-main-image]');
    const availabilityEl = document.querySelector('[data-product-availability]');
    const waitlistEl = document.querySelector('[data-waitlist]');
    // form.posted_successfully? is request-scoped: hide a foreign customer-form success so it never shows a false promise
    let waitlistLocked = false;
    if (waitlistEl && waitlistEl.querySelector('[data-waitlist-success]') && window.location.search.indexOf('waitlist=1') === -1) {
      waitlistEl.setAttribute('hidden', '');
      waitlistLocked = true;
    }
    // Shopify redirects to return_to on a successful post WITHOUT customer_posted=true, so
    // form.posted_successfully? is false here too — the query-string marker is the reliable signal.
    if (waitlistEl && window.location.search.indexOf('waitlist=1') !== -1) {
      const waitlistForm = waitlistEl.querySelector('form');
      const waitlistThanks = waitlistEl.querySelector('[data-waitlist-thanks]');
      if (waitlistForm) waitlistForm.setAttribute('hidden', '');
      if (waitlistThanks) waitlistThanks.removeAttribute('hidden');
      waitlistEl.removeAttribute('hidden');
      waitlistLocked = true;
    }
    function setAvailability(available) {
      if (availabilityEl) availabilityEl.textContent = available ? 'In stock' : 'Sold out';
      if (waitlistEl && !waitlistLocked) {
        if (available) waitlistEl.setAttribute('hidden', ''); else waitlistEl.removeAttribute('hidden');
      }
    }

    if (!optionButtons.length || !productJson.variants) return;

    // Shopify product.options is an array of option name strings
    const optionNames = productJson.options || [];

    optionButtons.forEach(btn => {
      btn.addEventListener('change', function() {
        const optionName = this.getAttribute('data-variant-option');
        const optionValue = this.getAttribute('data-variant-value');

        if (!optionName || !optionValue) return;

        // Collect all selected options from checked radio inputs
        const selectedOptions = {};
        optionNames.forEach(name => {
          const checked = document.querySelector('[data-variant-option="' + name + '"]:checked');
          if (checked) {
            selectedOptions[name] = checked.getAttribute('data-variant-value');
          }
        });

        // Find matching variant (Shopify uses option1, option2, option3)
        const matchingVariant = productJson.variants.find(v => {
          return optionNames.every((name, idx) => {
            return v['option' + (idx + 1)] === selectedOptions[name];
          });
        });

        if (matchingVariant) {
          if (variantIdInput) variantIdInput.value = matchingVariant.id;
          if (priceEl) priceEl.textContent = formatMoney(matchingVariant.price);

          if (mainImage && matchingVariant.featured_image) {
            mainImage.src = matchingVariant.featured_image.src;
          }

          if (addToCartBtn) {
            addToCartBtn.disabled = !matchingVariant.available;
            addToCartBtn.textContent = matchingVariant.available ? 'Add to Bag' : 'Sold Out';
          }
          setAvailability(matchingVariant.available);

          // Update URL
          const newUrl = new URL(window.location);
          newUrl.searchParams.set('variant', matchingVariant.id);
          window.history.replaceState({}, '', newUrl);
        }
      });
    });

    // Init active state from URL variant param
    const variantId = new URLSearchParams(window.location.search).get('variant');
    if (variantId) {
      const variant = productJson.variants.find(v => v.id === parseInt(variantId, 10));
      if (variant) {
        optionNames.forEach((name, idx) => {
          const val = variant['option' + (idx + 1)];
          if (!val) return;
          const radio = document.querySelector('[data-variant-option="' + name + '"][data-variant-value="' + val + '"]');
          if (radio) {
            radio.checked = true;
          }
        });
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (addToCartBtn) {
          addToCartBtn.disabled = !variant.available;
          addToCartBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
        }
        setAvailability(variant.available);
      }
    }
  }

  // ============================================
  // Add to Cart AJAX
  // ============================================
  function initAddToCart() {
    const statusEl = productForm.querySelector('[data-add-to-cart-status]');
    const productTitle = (productJson && productJson.title) || document.querySelector('h1')?.textContent.trim() || 'Item';
    function announce(msg) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      setTimeout(() => { statusEl.textContent = ''; }, 4000);
    }

    productForm.addEventListener('submit', function(e) {
      e.preventDefault();

      const formData = new FormData(this);
      const variantId = document.querySelector('[data-variant-id]')?.value;
      if (!variantId) return;

      const submitBtn = this.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: parseInt(formData.get('quantity') || 1, 10),
          }],
        }),
      })
        .then(response => {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(() => {
          announce(productTitle + ' added to your bag');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Added';
            setTimeout(() => {
              submitBtn.textContent = 'Add to Bag';
            }, 2000);
          }
          return fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              document.querySelectorAll('[data-cart-count]').forEach(el => {
                el.textContent = cart.item_count;
                el.classList.toggle('hidden', cart.item_count === 0);
              });
              document.dispatchEvent(new CustomEvent('cart:added', { detail: { cart: cart, trigger: submitBtn } }));
            })
            .catch(() => {});
        })
        .catch(() => {
          announce('Could not add to bag. Please try again.');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Add to Bag';
          }
        });
    });
  }

  // ============================================
  // Express Checkout — add then skip cart
  // ============================================
  function initExpressCheckout() {
    const expressBtn = productForm.querySelector('[data-express-checkout]');
    if (!expressBtn) return;

    expressBtn.addEventListener('click', function() {
      const variantId = document.querySelector('[data-variant-id]')?.value;
      if (!variantId) return;

      const quantity = parseInt(productForm.querySelector('[name="quantity"]')?.value || 1, 10);

      expressBtn.disabled = true;
      expressBtn.textContent = 'Redirecting...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: quantity }],
        }),
      })
        .then(response => {
          if (!response.ok) throw new Error('Add to cart failed');
          window.location.href = '/checkout';
        })
        .catch(() => {
          expressBtn.disabled = false;
          expressBtn.textContent = 'Express Checkout';
        });
    });
  }

  // ============================================
  // Share / Copy Link
  // ============================================
  function initShare() {
    const shareBtn = document.querySelector('[data-share-copy]');
    if (!shareBtn) return;

    shareBtn.addEventListener('click', function() {
      navigator.clipboard.writeText(window.location.href).then(() => {
        const original = this.innerHTML;
        this.innerHTML = '<svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>';
        setTimeout(() => { this.innerHTML = original; }, 2000);
      });
    });
  }

  // ============================================
  // Helpers
  // ============================================
  function formatMoney(cents) {
    if (!cents && cents !== 0) return '$0.00';
    const amount = (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const format = window.Ajura?.moneyFormat || '${{amount}}';
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  // Initialize
  initGallery();
  initVariantSelection();
  initAddToCart();
  initExpressCheckout();
  initShare();
})();
